import { render, staticRenderFns } from "./ViewComplaints.vue?vue&type=template&id=946f555e&scoped=true"
import script from "./ViewComplaints.vue?vue&type=script&lang=js"
export * from "./ViewComplaints.vue?vue&type=script&lang=js"
import style0 from "./ViewComplaints.vue?vue&type=style&index=0&id=946f555e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946f555e",
  null
  
)

export default component.exports